import { render, staticRenderFns } from "./pois.vue?vue&type=template&id=54a8dfb8&"
import script from "./pois.vue?vue&type=script&lang=js&"
export * from "./pois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports